/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { Spin } from '@ui/components';

export const DefaultSpinExample = () => <Spin />;

export const SmallSpinExample = () => <Spin size="small" />;

export const LargeSpinExample = () => <Spin size="large" />;

export const TipSpinExample = () => (
    <Spin tip="Loading campaigns…">
        <div style={{ minHeight: 80, padding: 16 }}>
            Content becomes available once loading completes.
        </div>
    </Spin>
);

export const WrappedContentSpinExample = () => (
    <Spin spinning>
        <div
            style={{
                background: '#f5f7fb',
                borderRadius: 6,
                minHeight: 96,
                padding: 16,
            }}
        >
            Wrapped content is blurred while the spinner is active.
        </div>
    </Spin>
);
